var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.85498 13L15.355 1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97607 11.7006C7.63128 11.9041 8.31401 12.005 9.00007 11.9999C11.7334 12.0459 14.5054 10.1246 16.2161 8.24192C16.596 7.82019 16.596 7.17966 16.2161 6.75792C15.5963 6.07806 14.9098 5.46229 14.1667 4.91992",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6086 3.1878C10.0825 3.0569 9.54192 2.99373 8.99988 2.9998C6.31255 2.95514 3.53322 4.83447 1.78588 6.75647C1.40601 7.17821 1.40601 7.81874 1.78588 8.24047C2.31717 8.82207 2.89704 9.35734 3.51922 9.84047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7.5C6.49982 6.8369 6.76316 6.20092 7.23204 5.73204C7.70092 5.26316 8.3369 4.99982 9 5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7.49902V7.49902C11.5002 8.16218 11.2369 8.79824 10.768 9.26722C10.2991 9.73621 9.66316 9.99969 9 9.99969",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCross);
export default __webpack_public_path__ + "static/media/eyeCross.0a58e635eed50faa4ffe926c47ab2d75.svg";
export { ForwardRef as ReactComponent };